/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../sharedComponents/Card";
// eslint-disable-next-line import/no-cycle
import { CardLink } from "../HeroCard";
import * as styles from "./CommonCard.module.scss";

const CommonCard = ({ className, image, header, content, link, button }) => (
	<Card className={cx(styles.commonCard, className)}>
		<Card.Image
			className={styles.commonCardImage}
			src={!image.srcSet && image.src}
			source={image.srcSet && image}
			alt={image.alt}
			fluid={image.fluid}
		/>
		<Card.BodyContainer className={cx(styles.commonCardContainer)}>
			<Card.Header className={styles.commonCardHeading}>{header}</Card.Header>

			{content && (
				<div className={styles.commonCardContent} dangerouslySetInnerHTML={{ __html: content }} />
			)}

			<div className={styles.commonCardButtons}>
				{button && (
					<div>
						<Card.Button to={button.link}>{button.text}</Card.Button>
					</div>
				)}
			</div>
		</Card.BodyContainer>
		{link?.to && <CardLink link={link.to} text={link.text} className={styles.commonCardLink} />}
	</Card>
);

CommonCard.propTypes = {
	className: PropTypes.string,
	image: PropTypes.shape({
		fluid: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
		fixed: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
		source: PropTypes.shape({
			src: PropTypes.string,
			srcSet: PropTypes.string,
			sizes: PropTypes.string,
		}),
		alt: PropTypes.string,
		src: PropTypes.string,
		srcSet: PropTypes.string,
	}),
	header: PropTypes.string.isRequired,
	content: PropTypes.object,
	link: PropTypes.shape({
		to: PropTypes.string.isRequired,
		target: PropTypes.string,
		icon: PropTypes.shape({
			svg: PropTypes.shape({
				content: PropTypes.string,
			}),
		}),
		text: PropTypes.string,
	}),
	button: PropTypes.shape({
		icon: PropTypes.string,
		onClick: PropTypes.func,
		text: PropTypes.string,
		link: PropTypes.string,
	}),
};

CommonCard.defaultProps = {
	className: "",
	image: undefined,
	content: undefined,
	button: undefined,
	link: undefined,
};

export default CommonCard;
export { CommonCard };
